<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <v-btn v-if="biggerButton" color="primary" depressed :height="height">
          <v-icon>mdi-printer</v-icon>
          {{ $t("print") }}
        </v-btn>
        <print-button v-else :small="false" :color="color" />
      </div>
    </template>
    <v-list>
      <v-list-item v-if="title">
        {{ title }}
      </v-list-item>
      <v-list-item @click="print('korisnici-za-stampu')">
        <v-list-item-title>
          {{ $t("tableLayout") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="print2(2, 'portrait')">
        <v-list-item-title>
          {{ $t("one_sheet_two_users") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="print2(1, 'landscape')">
        <v-list-item-title>
          {{ $t("one_sheet_one_user") }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import hasPrinting from "@/mixins/hasPrinting";
export default {
  mixins: [hasPrinting],
  props: {
    employees: {
      type: Array,
      required: true,
      default: () => [],
    },
    height: {
      type: String,
      required: false,
      default: "auto",
    },
    color: {
      type: String,
      default: "primary",
    },
    headers: {
      type: Array,
      default: () => [],
    },
    biggerButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    print() {
      this.printDocument({
        tables: [
          {
            headers: this.headers,
            items: this.employees,
          },
        ],
        title: this.title,
        subtitle: this.subtitle,
      });
    },
    getEmployeeQrText(qrSvgHtml) {
      console.log(this.employee);
      return `
        <div style="
          width: 420px;
          min-height: 160px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          display: flex;
          padding: 24px 32px;
          margin: 60px auto 0 auto;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        ">
          <div style="flex: 0 0 120px; display: flex; align-items: center; justify-content: center;">
            ${qrSvgHtml}
          </div>
          <div style="flex: 1; margin-left: 12px; display: flex; flex-direction: column; justify-content: start;">
            <div style="font-size: 15px; font-weight: bold; margin-bottom: 2px;">${
              this.employee.id
            }</div>
            <div style="font-size: 16px; font-weight: 600; margin-bottom: 2px;">
              ${this.toLatin(this.employee.name)} ${this.toLatin(this.employee.lastname)}
            </div>
            <div style="font-size: 13px; color: #555; margin-bottom: 12px;">${
              this.employee.email || ""
            }</div>
            <div style="display: flex; align-items: center; margin-top: 12px;">
              <img src="https://restorani.bitlab.host/img/o.png" alt="ordera.app" style="width: 24px; height: 24px; margin-right: 8px;">
              <span style="font-size: 13px; color: #888;">ordera.app</span>
            </div>
          </div>
        </div>
      `;
    },
    print2(count, orientation) {
      let beforeTableHtml = "";
      const getEmployeeQr = (employee) => {
        const qrCodeElem = document.getElementById("qrkodstampa" + employee.id);
        if (qrCodeElem) {
          // For qrcode-vue, the SVG is the first child
          const svg = qrCodeElem.querySelector("svg");
          if (svg) {
            return svg.outerHTML;
          } else {
            // fallback: maybe the element itself is svg
            if (qrCodeElem.tagName.toLowerCase() === "svg") {
              //return qrCodeElem.outerHTML;
              return qrCodeElem.innerHTML;
            }
          }
        }
      };
      this.printEmployeeCards({
        beforeTableHtml,
        count,
        employees: this.employees.map((employee) => ({
          ...employee,
          name: this.toLatin(employee.name),
          lastname: this.toLatin(employee.lastname),
          company:
            typeof employee.company === "string"
              ? this.toLatin(employee.company)
              : this.toLatin(employee.company?.name || ""),
          qr: getEmployeeQr(employee),
          externalCode: employee.external_code,
        })),
        mainTitle: this.subtitle ? "" : this.title,
        subTitle: this.subtitle || "",
        orientation,
      });
    },
  },
};
</script>
